import React, { useEffect, useRef, useState } from 'react'
import './banner.css'
import Mangopng from '../../assets/mango.png'
import Bottle from '../../assets/img/Bottel.png'
import Flavour from "../../assets/img/flavour.png"
import { gsap } from "gsap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import OrangeOne from "../../assets/img/Orange/orangeBlur.png";
import OrangeTwo from "../../assets/img/Orange/orangeBlur.png";
import OrangeThree from "../../assets/img/Orange/orangeBlur.png";
import OrangeFour from "../../assets/img/Orange/orangeBlur.png";
import litchiOne from "../../assets/img/Litchi/litchi2.png";
import litchiTwo from "../../assets/img/Litchi/litchiBlur.png";
import litchiThree from "../../assets/img/Litchi/litchicut.png";
import litchiFour from "../../assets/img/Litchi/litchifull.png";
import mojitoOne from "../../assets/img/Mojito/mojito.png";
import mojitoTwo from "../../assets/img/Mojito/mojitoblur.png";
import mojitoThree from "../../assets/img/Mojito/mojitocut.png";
import mojitoFour from "../../assets/img/Mojito/mojitocut2.png";
import caneImage from "../../assets/img/Bottel.png";
import labelsImage from "../../assets/img/flavour.png";
import orangeBottel from "../../assets/Bottle/Orange.png";
import litchiBottel from "../../assets/Bottle/Litchi.png";
import mojitoBottel from "../../assets/Bottle/Mojito.png";

const Banner = ({fruit}) => {
  const bottleRef = useRef(null);
  const h1Texts = ["ORANGE", "LITCHI", "MOJITO"];
  // Bottle images for each heading
  const bottleImages = {
    ORANGE: orangeBottel,
    LITCHI: litchiBottel,
    MOJITO: mojitoBottel,
  };
  const themeColors = ["var(--pear-background)", "var(--apple-background)", "var(--exotic-background)"];
  const logoColors = ["var(--pear-logo)", "var(--apple-logo)", "var(--exotic-logo)"];
  const imageSources = {
    ORANGE: [
      { src: OrangeOne, className: "image-one" },
      { src: OrangeTwo, className: "image-two" },
      { src: OrangeThree, className: "image-three" },
      { src: OrangeFour, className: "image-four" }
    ],
    LITCHI: [
      { src: litchiOne, className: "image-one" },
      { src: litchiTwo, className: "image-two" },
      { src: litchiThree, className: "image-three" },
      { src: litchiFour, className: "image-four" }
    ],
    MOJITO: [
      { src: mojitoOne, className: "image-one" },
      { src: mojitoTwo, className: "image-two" },
      { src: mojitoThree, className: "image-three" },
      { src: mojitoFour, className: "image-four" }
    ],
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  // Theme color for current fruit
  const currentThemeColor = themeColors[currentIndex];
  const [currentPosition, setCurrentPosition] = useState(0);
  const scrollTimeoutRef = useRef(null); // To debounce scroll
  const [isLoaded, setIsLoaded] = useState(false);


  useEffect(() => {
    gsap.from(".fruit-image", { y: "0", delay: 0.5 });
    gsap.to(".fruit-image img", {
      x: "random(-20, 20)",
      y: "random(-20, 20)",
      zIndex: 22,
      duration: 2,
      ease: "none",
      yoyo: true,
      repeat: -1,
    });
    setIsLoaded(true);
    // Responsive: handle resize for mobile
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCurrentPosition(0); // Reset position for mobile
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    if (currentIndex < h1Texts.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      if (window.innerWidth >= 768) {
        setCurrentPosition((prev) => prev - 100);
      }
      // Animate bottle down
      if (bottleRef.current) {
        gsap.to(bottleRef.current, {
          y: 60,
          duration: 1.2,
          ease: "power2.inOut",
          onComplete: () => {
            gsap.to(bottleRef.current, { y: 0, duration: 1.2, ease: "power2.inOut" });
          }
        });
      }
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
      if (window.innerWidth >= 768) {
        setCurrentPosition((prev) => prev + 100);
      }
      // Animate bottle up
      if (bottleRef.current) {
        gsap.to(bottleRef.current, {
          y: -60,
          duration: 1.2,
          ease: "power2.inOut",
          onComplete: () => {
            gsap.to(bottleRef.current, { y: 0, duration: 1.2, ease: "power2.inOut" });
          }
        });
      }
    }
  };

   useEffect(() => {
    gsap.to(".logo", { color: logoColors[currentIndex], duration: 1 });
    gsap.from(".h1", { y: "20%", opacity: 2, duration: 0.5 });
    gsap.from(".fruit-image", { y: currentIndex > 0 ? "0" : "0", delay: 0.4, duration: 0.4 });
  }, [currentIndex, logoColors]);
   
  // Scroll Event Handler
   const handleScroll = (event) => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {
      if (event.deltaY > 0) {
        handleNext();
      } else {
        handlePrev();
      }
    }, 100); // Adding a slight delay to prevent rapid scrolling
  };

  return (
    <div onWheel={handleScroll} className="banner responsive-banner">
      <div className="text responsive-text">
        <h1 className="h1 responsive-h1">{h1Texts[currentIndex]}</h1>
        <div className="cane-image responsive-cane-image" style={{ display: isLoaded ? "block" : "none" }}>
          <img
            ref={bottleRef}
            src={bottleImages[h1Texts[currentIndex]]}
            alt="Bottle"
            className={`responsive-bottle${h1Texts[currentIndex] === 'ORANGE' ? ' orange-flip' : ''} banner-bottle-img`}
            style={{ margin: '0 auto', display: 'block', maxWidth: window.innerWidth < 768 ? '120px' : '220px', width: '100%', height: 'auto', transition: 'max-width 0.3s' }}
          />
        </div>
      </div>
      <div className="section-container-main responsive-section-main">
        <div className="section-container responsive-section-container" style={{ left: window.innerWidth >= 768 ? `${currentPosition}%` : "0", transition: "all 0.5s ease-in-out" }}>
          {h1Texts.map((fruit, index) => (
            <section className="section responsive-section" key={index}>
              <div className="fruit-images responsive-fruit-images">
                {imageSources[fruit]?.map(({ src, className }, i) => (
                  <div className={`fruit-image ${className} responsive-fruit-image`} key={i}>
                    <img src={src} alt={`${fruit}-image`} className="responsive-fruit-img" />
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
      <div className="banner-controls responsive-controls" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        bottom: window.innerWidth < 768 ? '10px' : '40px',
        left: 0,
        width: '100%',
        zIndex: 10,
        gap: window.innerWidth < 768 ? '20px' : '40px',
      }}>
        <button
          className="banner-btn responsive-btn"
          style={{
            fontSize: window.innerWidth < 768 ? '1.5rem' : '2rem',
            padding: window.innerWidth < 768 ? '0.5rem 1.2rem' : '0.7rem 2rem',
            borderRadius: '50%',
            background: '#fff',
            border: '2px solid #ff7f00',
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
            cursor: 'pointer',
            opacity: currentIndex === 0 ? 0.5 : 1,
            transition: 'all 0.3s',
          }}
          onClick={handlePrev}
          disabled={currentIndex === 0}
        >
          <FaChevronLeft />
        </button>
        <button
          className="banner-btn responsive-btn"
          style={{
            fontSize: window.innerWidth < 768 ? '1.5rem' : '2rem',
            padding: window.innerWidth < 768 ? '0.5rem 1.2rem' : '0.7rem 2rem',
            borderRadius: '50%',
            background: '#fff',
            border: '2px solid #ff7f00',
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
            cursor: 'pointer',
            opacity: currentIndex === h1Texts.length - 1 ? 0.5 : 1,
            transition: 'all 0.3s',
          }}
          onClick={handleNext}
          disabled={currentIndex === h1Texts.length - 1}
        >
          <FaChevronRight />
        </button>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .banner-controls.responsive-controls {
            position: absolute !important;
            bottom: 10px !important;
            left: 0 !important;
            width: 100% !important;
            gap: 20px !important;
          }
          .banner-btn.responsive-btn {
            font-size: 1.5rem !important;
            padding: 0.5rem 1.2rem !important;
          }
          .banner-bottle-img {
            max-width: 120px !important;
            width: 100% !important;
            height: auto !important;
          }
        }
        @media (min-width: 769px) {
          .banner-bottle-img {
            max-width: 220px !important;
            width: 100% !important;
            height: auto !important;
          }
        }
      `}</style>
    </div>
    // Pass theme color to parent via callback or context
  )
}


export default Banner



// import { useEffect, useRef } from "react";
// import { Canvas, useFrame } from "@react-three/fiber";
// import { TextureLoader } from "three";
// import { OrbitControls } from "@react-three/drei";
// import gsap from "gsap";

// const Bottle = () => {
//   const bottleRef = useRef();
//   const texture = new TextureLoader().load("/Bottle.png"); // Image ko public folder me rakhein

//   useFrame(() => {
//     if (bottleRef.current) {
//       bottleRef.current.rotation.y += 0.01; // Auto rotate
//     }
//   });

//   useEffect(() => {
//     const handleScroll = () => {
//       const rotationY = window.scrollY * 0.005;
//       gsap.to(bottleRef.current.rotation, { y: rotationY, duration: 1 });
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <mesh ref={bottleRef}>
//       <cylinderGeometry args={[0.5, 0.5, 2, 32]} />
//       <meshStandardMaterial map={texture} />
//     </mesh>
//   );
// };

// const BottleViewer = () => {
//   return (
  
  
//     <Canvas style={{
//       position: "fixed",
//       top: 0,
//       left: "50%",
//       transform: "translateX(-50%)",
//       overflow: "hidden",
//       pointerEvents: "none",
//       zIndex: 30,
//     }}
//     shadows
//     dpr={[1, 1.5]}
//     gl={{ antialias: true }} camera={{ position: [0, 0, 3] }}>
//       <ambientLight intensity={0.5} />
//       <directionalLight position={[2, 2, 2]} intensity={1} />
//       <Bottle />
//       <OrbitControls />
//     </Canvas>
//   );
// };




// export default BottleViewer;
